import { useState } from "react";
import Landing from "./pages/Landing";
import Entry from "./pages/Entry";

function App() {
  const [started, setStarted] = useState(false);

  return (
    <>
      {started ? (
        <Entry />
      ) : (
        <Landing onStart={() => setStarted(true)} />
      )}
    </>
  );
}

export default App;
